import { defineMessages } from 'react-intl';
import type { ApiContractorKind } from '@allbin/mobilix-api-client';

/**
 * Both kinds a contractor can have (HK-1114). `contractor` is one of the
 * customer's own contractors; `road_authority` is an external road owner such
 * as a Trafikverket maintenance district, kept as a contractor so assignment
 * and mail can be reused.
 *
 * Single source of truth for the kinds the UI knows: the form's dropdown
 * options and its validation are both derived from this tuple.
 */
export const contractorKinds = [
  'contractor',
  'road_authority',
] as const satisfies readonly ApiContractorKind[];

export const defaultContractorKind: ApiContractorKind = 'contractor';

export const contractorKindMessages = defineMessages<ApiContractorKind>({
  contractor: {
    id: 'contractor_kind.contractor',
    defaultMessage: 'Contractor',
  },
  road_authority: {
    id: 'contractor_kind.road_authority',
    defaultMessage: 'Road authority',
  },
});

export const isContractorKind = (value: unknown): value is ApiContractorKind =>
  typeof value === 'string' &&
  (contractorKinds as readonly string[]).includes(value);

/**
 * Label for a contractor's kind. A missing kind (older API) or one this UI
 * does not know yet renders as the default kind instead of crashing.
 */
export const contractorKindMessage = (
  kind: unknown,
): (typeof contractorKindMessages)[ApiContractorKind] =>
  contractorKindMessages[isContractorKind(kind) ? kind : defaultContractorKind];
